import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalContent from 'components/base/secure/modals/modal-content';
import ModalHeader from 'components/base/secure/modals/modal-header';
import { Trans, withNamespaces } from 'react-i18next';
import Money from 'components/formatters/money-formatter';

@withNamespaces()
class BudgetItemConflictModal extends Component {
    constructor(props) {
        super(props);

        this.update = this.update.bind(this);
        this.dismiss = this.dismiss.bind(this);
    }

    update() {
        this.props.onSuccess();
    }

    dismiss() {
        this.props.onDismiss();
    }

    render() {
        const { t, conflict, newItem } = this.props;
        const categoryName = (conflict.category.category ? t(conflict.category.category.name) + ' - ' : '')
            + t(conflict.category.name);

        return (
            <ModalContent>
                <ModalHeader
                    title={t('BUDGET.BUDGET_ITEM.ADD_CONFLICT_TITLE')}
                />
                <div className="modal-body">
                    <Trans i18nKey="BUDGET.BUDGET_ITEM.ADD_CONFLICT_TEXT">
                        <strong>{{categoryName}}</strong>
                    </Trans>
                    <br />
                    <table className="table table-condensed">
                        <thead>
                        <tr>
                            <th>{t('COMMON.BEFORE')}</th>
                            <th>{t('COMMON.AFTER')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><Money value={conflict.amount}/></td>
                            <td><Money value={newItem.amount}/></td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="modal-footer modal-footer-space">
                        <button type="button"
                                className="btn btn-primary"
                                onClick={this.update}
                        >
                            {t('COMMON.UPDATE')}
                        </button>
                        <button type="button"
                                className="btn btn-default"
                                onClick={this.dismiss}
                        >
                            {t('COMMON.CANCEL')}
                        </button>
                    </div>
                </div>
            </ModalContent>
        )
    }
}

BudgetItemConflictModal.propTypes = {
    /** A budget item which is conflicting */
    conflict: PropTypes.object.isRequired,
    
    /** An object that user wanted to save */
    newItem: PropTypes.object.isRequired,

    /** Function that gets executed when the modal is cancelled */
    onDismiss: PropTypes.func.isRequired,

    /** A function that will be called after a successful update */
    onSuccess: PropTypes.func.isRequired,
};

export default BudgetItemConflictModal;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-modals/budget-item-conflict-modal.js